module.exports = __webpack_public_path__ + "static/img/3.8fb089a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/UltralowTemperature/R23/3.jpg
// module id = s15E
// module chunks = 1